import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, SpeakerSlider, Sponsors, Tickets, PortfolioSection, Registration, ScheduleTab } from '../../sections';
import { Banner, VenueDetails } from '../../components';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Hero section with a call-to-action */}
      <About /> {/* About the company */}
      <Services /> {/* Services offered */}
      <Counter /> {/* Company stats and achievements */}
      <ScheduleTab /> {/* Event schedule tab */}
      <SpeakerSlider /> {/* Speaker slider section */}
      <Banner /> {/* Promotional banner */}
      <Tickets /> {/* Ticket pricing section */}
      <Registration /> {/* Registration Section */}
      <Testimonials /> {/* Client reviews */}
      <PortfolioSection /> {/* Portfolio showcase */}
      <Blogs /> {/* Latest blog posts */}
      <NewsletterSection /> {/* Newsletter subscription form */}
      <VenueDetails /> {/* Venue Info */}
      <Sponsors /> {/* Sponsors Section */}
    </div>
  )

}

export default HomePage;